import { query,mutate,destroy, update } from "../../defaults/fetch";
import {useEffect,useState} from "react";


export const useCreateBudgetApproval = ()=>{
    const createBudgetApproval = async (body)=>{
        const url = `budgetapprovalstage/create`;
        const response = await mutate(url,true,body);
        return response.message;
    }

    return createBudgetApproval;
}


export const useFetchBudgetApprovalStages = (flag)=>{
    const [budgetApprovals,setBudgetApprovals] = useState([]);
    const [loading,setLoading] = useState(false);


    useEffect(()=>{
        const getAllBudgetApprovals = async ()=>{
            setLoading(true);
            const url = `budgetapprovalstage/get-all`
            const qs = {
                page:0,
                size:50
            };
            const {data} = await query(url,qs);
            setLoading(false);
            setBudgetApprovals(data)
        }
        getAllBudgetApprovals();
    },[flag]);

    return {loading,budgetApprovals};
}


export const useUpdateBudgetApprovalStage = ()=>{
    const updateBudgetApprovalStage = async (id,body)=>{
        const url = `budgetapprovalstage/update/${id}`;
        const {message} = await update(url,body);
        return message;
    }
    return updateBudgetApprovalStage;
}

export const useDeleteBudgetApprovalStage = ()=>{
    const deleteBudgetApprovalStage = async (id) =>{
        const url =`budgetapprovalstage/delete/${id}`;
        const {message} = await destroy(url);
        return message;
    }
    return deleteBudgetApprovalStage;
}
